export default function CachePromise() {
  var promiseCache = {};
  return function (name, fn) {
    // if the function has been run return the existing promise
    // otherwise run the function and return the result
    return function () {
      return new Promise(function ($return, $error) {
        if (!promiseCache[name]) {
          promiseCache[name] = fn();
        }
        return $return(promiseCache[name]);
      });
    };
  };
}
//# sourceMappingURL=promise-cache.js.map